<template>
  <div>
    <el-row class="version-card">
      <div class="mb-10 text-a-r">
        <el-button
          type="primary"
          size="mini"
          style="padding: 5px 10px;"
          v-if="sfqyGxbj == '1'"
          @click="addXtgx"
          icon="el-icon-plus"
          >{{$t('xtgx.Newlog')}}</el-button
        >
        <el-button
          type="primary"
          size="mini"
          style="padding: 5px 10px;"
          @click="updateXt"
          icon="el-icon-refresh"
          >{{$t('xtgx.Checkupdates')}}</el-button
        >
      </div>
      <el-timeline>
        <el-timeline-item v-for="(item, index) in versionData" :key="index">
          <el-card>
            <h2 class="pb-5 dy-flex jy-c-sb">
              <div>{{ item.version + item.title }}</div>
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  class="ml-10"
                  style="padding: 5px 10px;"
                  v-if="sfqyGxbj == '1'"
                  @click="editXtgx(item)"
                  icon="el-icon-edit"
                  >{{$t('xtgx.edit')}}
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  class="ml-10"
                  style="padding: 5px 10px;"
                  v-if="index == 0 && sfqyGxbj == '1'"
                  @click="delXtgx(item)"
                  icon="el-icon-delete"
                  >{{$t('xtgx.delete')}}
                </el-button>
              </div>
            </h2>
            <p class="dy-flex align-i-c pb-10">
              <el-button
                size="mini"
                round
                :type="
                  item.type == '1'
                    ? 'success'
                    : item.type == '2'
                    ? 'primary'
                    : 'danger'
                "
                style="padding: 5px; margin-left: 0px"
              >
                {{
                  item.type == "1"
                    ? "一般更新"
                    : item.type == "2"
                    ? "重要更新"
                    : "重大升级"
                }}
              </el-button>
              <span class="ml-10 color-g">{{ item.time }}</span>
            </p>
            <el-row :gutter="40">
              <el-col :span="8" v-if="item.xgn">
                <div class="gxmenu">
                  <p class="pb-5">
                    <!-- <i class="el-icon-menu color-primary mr-5" /> -->
                    <svg-icon
                      class="mr-5 wt-14 ht-14"
                      icon-class="icon_function"
                    ></svg-icon>
                    <span class="fw-bold">{{$t('xtgx.newfunction')}}</span>
                  </p>
                  <p v-for="(it, ind) in item.xgn" :key="ind" class="content">
                    {{ it }}
                  </p>
                </div>
              </el-col>
              <el-col :span="8" v-if="item.yh">
                <div class=" gxmenu">
                  <p class="pb-5">
                    <!-- <i class="el-icon-success color-primary mr-5" /> -->
                    <svg-icon
                      class="mr-5 wt-14 ht-14"
                      icon-class="icon_right"
                    ></svg-icon>
                    <span class="fw-bold">{{$t('xtgx.optimization')}}</span>
                  </p>
                  <p v-for="(it, ind) in item.yh" :key="ind" class="content">
                    {{ it }}
                  </p>
                </div>
              </el-col>
              <el-col :span="8" v-if="item.xf">
                <div class="gxmenu">
                  <p class="pb-5">
                    <!-- <i class="el-icon-s-claim color-primary mr-5" /> -->
                    <svg-icon
                      class="mr-5 wt-14 ht-14"
                      icon-class="icon_repair"
                    ></svg-icon>
                    <span class="fw-bold">{{$t('xtgx.repair')}}</span>
                  </p>
                  <p v-for="(it, ind) in item.xf" :key="ind" class="content">
                    {{ it }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-row>
    <!-- <el-row
      v-for="(item, index) in versionData"
      class="version-card"
      :key="index"
    >
      <div>
        <el-button
          size="small"
          :type="
            item.type == '1'
              ? 'success'
              : item.type == '2'
              ? 'primary'
              : 'warning'
          "
          >{{ item.title }}</el-button
        >
        <div class="ver-time">
          <h2>{{ item.version }}</h2>
          <el-button type="text" @click="updateXt" v-if="index == 0"
            >更新数据</el-button
          >
          <span>{{ item.time }}</span>
        </div>
        <el-divider></el-divider>
        <div class="mt-10">
          <p class="content-t mb-20">主要更新内容（点击可查看操作指南）：</p>
          <p v-for="(it, ind) in item.content" :key="ind" class="content ml-30">
            {{ it }}
          </p>
        </div>
      </div>
    </el-row> -->

    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 5% 0 5%">
        <el-form :model="ruleForm" ref="ruleForm" size="small" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label-position="top"
                label="系统版本"
                prop="version"
              >
                <el-input
                  v-model="ruleForm.version"
                  placeholder="请输入系统版本"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-position="top" label="日志标题" prop="title">
                <el-input
                  v-model="ruleForm.title"
                  placeholder="请输入日志标题"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-position="top" label="更新时间" prop="time">
                <el-date-picker
                  v-model="ruleForm.time"
                  type="datetime"
                  placeholder="请选择更新时间"
                  style="width:100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-position="top" label="更新等级" prop="lave">
                <el-select
                  v-model="ruleForm.lave"
                  placeholder="请选择更新等级"
                  style="width:100%"
                  @change="laveChange"
                  :disabled="dialogType == 'add' ? false : true"
                >
                  <el-option
                    v-for="item in laveOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="dy-flex jy-c-sb">
              <label style="font-weight: bold;color: #606266">更新内容</label>
              <p class="color-r">*至少填写一条内容，每条内容分行</p>
            </el-col>
            <el-col :span="24">
              <el-form-item label-position="top">
                <label slot="label">
                  <!-- <i class="el-icon-menu color-primary mr-5" /> -->
                  <svg-icon
                    class="mr-5 wt-14 ht-14"
                    icon-class="icon_function"
                  ></svg-icon>
                  <span class="fw-bold">新功能</span>
                </label>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 100 }"
                  placeholder="请输入内容"
                  v-model="ruleForm.xgn"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-position="top">
                <label slot="label">
                  <!-- <i class="el-icon-success color-primary mr-5" /> -->
                  <svg-icon
                    class="mr-5 wt-14 ht-14"
                    icon-class="icon_right"
                  ></svg-icon>
                  <span class="fw-bold">优化</span>
                </label>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 100 }"
                  placeholder="请输入内容"
                  v-model="ruleForm.yh"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-position="top" label="更新等级">
                <label slot="label">
                  <!-- <i class="el-icon-s-claim color-primary mr-5" /> -->
                  <svg-icon
                    class="mr-5 wt-14 ht-14"
                    icon-class="icon_repair"
                  ></svg-icon>
                  <span class="fw-bold">修复</span>
                </label>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 100 }"
                  placeholder="请输入内容"
                  v-model="ruleForm.xf"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label-position="left">
                <label slot="label">
                  <span class="fw-bold">是否更新</span>
                </label>
                <el-switch
                  v-model="ruleForm.sfgx"
                  active-color="#13ce66"
                  active-value="1"
                  inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="conmitForm"
          >确认</el-button
        >
        <el-button type="warning" size="small" @click="cancleForm"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as xtsz from "@/api/xtsz";
export default {
  name: "xtgx",
  computed: {},
  data() {
    return {
      versionData: [],
      sfqyGxbj: "",
      dialogFormVisible: false,
      dialogTitle: "", // 模态框标题
      dialogTitleIcon: "", // 角色模态框标题图标
      ruleForm: {
        version: "",
        title: "",
        time: "",
        lave: "",
        xgn: "",
        yh: "",
        xf: "",
        xgnArr: [],
        yhArr: [],
        xfArr: [],
        sfgx: "0",
      },
      rules: {
        version: [{ required: true, message: "系统版本号", trigger: "blur" }],
        title: [{ required: true, message: "请输入日志标题", trigger: "blur" }],
        time: [{ required: true, message: "请选择时间", trigger: "blur" }],
        lave: [{ required: true, message: "请选择等级", trigger: "blur" }],
      },
      laveOptions: [
        {
          value: "1",
          label: "一般更新",
        },
        {
          value: "2",
          label: "重要更新",
        },
        {
          value: "3",
          label: "重大升级",
        },
      ],
      isblxg: false, // 是否保留修改
      dialogType: "",
    };
  },
  watch: {},
  methods: {
    // 系统更新
    updateXt() {
      xtsz.updateXt().then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
        }
      });
    },
    addXtgx() {
      this.dialogType = "add";
      this.dialogTitle = "新增版本";
      this.dialogTitleIcon = "el-icon-plus";
      this.dialogFormVisible = true;
      if (!this.isblxg) {
        let vsion = this.versionData[0].version;
        let arr = vsion.split(".");
        this.ruleForm.version =
          arr[0] + "." + arr[1] + "." + (parseInt(arr[2]) + 1);
      }
    },
    editXtgx(row) {
      this.dialogType = "edit";
      this.dialogTitle = "修改版本";
      this.dialogTitleIcon = "el-icon-edit-outline";
      this.dialogFormVisible = true;
      this.ruleForm.version = row.version;
      this.ruleForm.title = row.title;
      this.ruleForm.lave = row.type;
      this.ruleForm.time = row.time;
      this.ruleForm.sfgx = row.sfgx;
      let xgn = "";
      let yh = "";
      let xf = "";
      if (row.xgn && row.xgn.length > 0) {
        row.xgn.forEach((item) => {
          xgn = xgn + item + "\n";
        });
      }
      if (row.yh && row.yh.length > 0) {
        row.yh.forEach((item) => {
          yh = yh + item + "\n";
        });
      }
      if (row.xf && row.xf.length > 0) {
        row.xf.forEach((item) => {
          xf = xf + item + "\n";
        });
      }
      this.ruleForm.xgn = xgn;
      this.ruleForm.yh = yh;
      this.ruleForm.xf = xf;
    },
    delXtgx(row) {
      xtsz.delXtgx(row).then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
        }
      });
    },
    laveChange(val) {
      if (val == "1") {
        let vsion = this.versionData[0].version;
        let arr = vsion.split(".");
        this.ruleForm.version =
          arr[0] + "." + arr[1] + "." + (parseInt(arr[2]) + 1);
      } else {
        let vsion = this.versionData[0].version;
        let arr = vsion.split(".");
        this.ruleForm.version = arr[0] + "." + (parseInt(arr[1]) + 1) + ".0";
      }
    },
    conmitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (
          this.ruleForm.xgn == "" &&
          this.ruleForm.yh == "" &&
          this.ruleForm.xf == ""
        ) {
          this.$message.error("请至少填写一条更新内容！");
        } else {
          this.ruleForm.xgn = this.ruleForm.xgn.split("\n");
          this.ruleForm.yh = this.ruleForm.yh.split("\n");
          this.ruleForm.xf = this.ruleForm.xf.split("\n");
          this.ruleForm.type = this.ruleForm.lave;
          // this.ruleForm.sfgx = "0";
          console.log("this.ruleForm", this.ruleForm);
          if (this.dialogType == "add") {
            xtsz.addXtgx2(this.ruleForm).then((res) => {
              if (res.data.code == "200") {
                this.dialogFormVisible = false;
                this.$message.success(res.data.message);
              }
            });
          } else {
            xtsz.updateXtgx(this.ruleForm).then((res) => {
              if (res.data.code == "200") {
                this.dialogFormVisible = false;
                this.$message.success(res.data.message);
              }
            });
          }
          this.ruleForm = {
            version: "",
            title: "",
            time: "",
            lave: "",
            xgn: "",
            yh: "",
            xf: "",
            xgnArr: [],
            yhArr: [],
            xfArr: [],
          };
        }
      });
    },
    handleClose(done) {
      this.$confirm("是否保留当前填写内容？", {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t("common.confirmBtn"),
        cancelButtonText: this.$t("common.cancelBtn"),
      })
        .then((res1) => {
          this.isblxg = true;
          done();
        })
        .catch((action) => {
          this.isblxg = false;
          this.ruleForm = {
            version: "",
            title: "",
            time: "",
            lave: "",
            xgn: "",
            yh: "",
            xf: "",
            xgnArr: [],
            yhArr: [],
            xfArr: [],
          };
          done();
        });
    },
    cancleForm() {
      this.isblxg = false;
      this.ruleForm = {
        version: "",
        title: "",
        time: "",
        lave: "",
        xgn: "",
        yh: "",
        xf: "",
        xgnArr: [],
        yhArr: [],
        xfArr: [],
      };
      this.dialogFormVisible = false;
    },
  },
  created() {},
  mounted() {
    xtsz.getXtgxs().then((res) => {
      let val = [];
      val = res.data.data.versions;
      for (let i = val.length - 1; i >= 0; i--) {
        this.versionData.push(val[i]);
      }
      this.sfqyGxbj = res.data.data.sfqyGxbj;
    });
  },
};
</script>

<style lang="scss" scoped>
.version-card {
  padding: 30px;
  margin-bottom: 30px;
  background-color: #fff;
}
.el-col {
  border-radius: 4px;
}
.gxmenu {
  background-color: #f4f4f5;
  padding: 10px 15px;
}
.ver-time {
  height: 35px;
  width: 90%;
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  span {
    font-size: 15px;
    color: #999;
    line-height: 35px;
  }
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.content-t {
  color: #999;
}
.content {
  color: #999;
}
</style>
